import { GameData } from '../../../server/data/GameData';
import { StopPresentation } from "../Normal/StopPresentation";
import { SanEngineController } from "../../../engine/SanEngineController";
import { SanEngineManager } from '../../../engine/SanEngineManager';
import { GameSetting } from '../../../../core/setting/GameSetting';
import { SanQuentin2 } from '../../../SanQuentin2';

export class SetupStopPresentation extends StopPresentation {

    protected get basicStopDelay():number[]{

        let delay:number[] = [0, 0.5, 1, 1.5, 2];
        
        if(SanEngineManager.isQuickStop){
            delay = GameSetting.isFastSpin ? [0,0,0,0,0] : [0,0.1,0.2,0.3,0.4];
        }
        return delay;
    }

    protected createStopSpins(): void {
        SanEngineManager.RAll((rc: SanEngineController) => rc.createStop({
            stops: () => this.onStop(rc),
            bounce: () => this.onBounce(rc),
            stopped: () => this.onStopped(rc)
        }, true));
    }
  
    public setGameData(data: GameData): void {
        super.setGameData(data);
    }

    public createPresentation(skip:Function): void {
        super.createPresentation(skip);
    }

    protected onStop(rc: SanEngineController): void { 
    }

    protected onBounce(rc: SanEngineController): void { 
        this.playBounceSound(rc.reelID);
        rc.changeAlpha(0, rc.stopDuration / 2);
        rc.AllWindowSymbols.forEach(sym => {
            if(sym.symName != "X")
                sym.attentionFlash(0, rc.stopDuration / 2);
        })
        SanQuentin2.setupPhase.ApplyBottomTextVal(rc.reelID,this._gameData.Reel.setupPositions[rc.reelID].length);
    }
}